import React from 'react'
import { string, object } from 'prop-types'
import {
  EMPTY_OBJECT,
  ALL,
  PROJECTS,
  IMAGES,
  PRODUCTS,
  FOLDERS,
  ARTICLES,
  COMPETITIONS,
  EVENTS,
  PROFESSIONALS
} from '../../utils/constants'
import AggregationItem from './AggregationItem'

const fixedAggregations = [ALL, PROJECTS, IMAGES, PRODUCTS, FOLDERS, ARTICLES, COMPETITIONS, EVENTS, PROFESSIONALS]
const filteredAgregations = [PROJECTS, IMAGES]

const Aggregations = ({ active = '', aggregations = EMPTY_OBJECT, query = '', site = '', scope = '' }) => {
  // Avoiding to show Folders aggregation on Image Search
  if (active !== IMAGES) aggregations.folders = { doc_count: 1, view_more: '#' }

  if (site === 'us') {
    // Adding Professional link to Aggregations
    aggregations.professionals = { view_more: 'https://www.archdaily.com/search/professionals', doc_count: 1 }

    // Filtering aggregations in order to show only Projects and Images in their respective search engines.
    if (!query) {
      aggregations = Object.keys(aggregations)
        .filter(key => filteredAgregations.includes(key))
        .reduce((obj, key) => {
          obj[key] = aggregations[key]
          return obj
        }, {})
    } else if (active === PROJECTS) delete aggregations.images // Removing images from aggrgations if we have a query
  }

  return (
    <nav className='aggregations__container'>
      <ul>
        {fixedAggregations.map(
          key =>
            fixedAggregations.includes(key) &&
            aggregations.hasOwnProperty(key) && aggregations[key].doc_count > 0 && (
              <AggregationItem
                count={aggregations[key].doc_count}
                isActive={active === key}
                key={`${key}-aggregation`}
                link={aggregations[key].view_more}
                query={query}
                text={key}
                site={site}
                scope={scope}
              />
            )
        )}
      </ul>
    </nav>
  )
}

Aggregations.propTypes = {
  active: string,
  aggregations: object.isRequired,
  query: string,
  site: string,
  scope: string
}

export default Aggregations
